import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'app-keepa-graph',
  standalone: true,
  imports: [PopoverModule],
  templateUrl: './keepa-graph.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./keepa-graph.component.sass'],
})
export class KeepaGraphComponent {
  @Input() asin!: string;
  @Input() showNew: boolean = true;
  @Input() showUsed: boolean = true;
  @Input() showAmazon: boolean = true;
  @Input() showBuyBox: boolean = true;
  @Input() showSalesRank: boolean = true;
  @Input() showFBA: boolean = true;

  getKeepaImageUrl(width: number, height: number): string {
    const params: string[] = [];
    params.push(`asin=${this.asin}`);
    params.push(`domain=co.jp`);
    params.push(`width=${width}`);
    params.push(`height=${height}`);

    // Keepaの価格タイプパラメータ（数値で指定）
    const priceTypes: string[] = [];
    if (this.showAmazon) priceTypes.push('0'); // Amazon価格
    if (this.showNew) priceTypes.push('1'); // 新品価格
    if (this.showUsed) priceTypes.push('2'); // 中古価格
    if (this.showSalesRank) priceTypes.push('3'); // セールスランク
    if (this.showBuyBox) priceTypes.push('18'); // BuyBox価格
    if (this.showFBA) priceTypes.push('16'); // FBA価格

    if (priceTypes.length > 0) {
      params.push(`csv=${priceTypes.join(',')}`);
    }

    // Nginx プロキシ経由でアクセス（CORB 回避 + キャッシュ有効）
    return `/api/keepa/graph?${params.join('&')}`;
  }

  getKeepaLinkUrl(): string {
    return `https://keepa.com/#!product/5-${this.asin}`;
  }
}
